/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `NOT_STARTED` - NOT_STARTED
 * * `PENDING` - PENDING
 * * `RUNNING` - RUNNING
 * * `RETRY` - RETRY
 * * `FAILED` - FAILED
 * * `SUCCESS` - SUCCESS
 * * `SUCCESS_WITH_ERRORS` - SUCCESS_WITH_ERRORS
 * @export
 */
export const AssessmentStatusEnum = {
  notStarted: 'NOT_STARTED',
  pending: 'PENDING',
  running: 'RUNNING',
  retry: 'RETRY',
  failed: 'FAILED',
  success: 'SUCCESS',
  successWithErrors: 'SUCCESS_WITH_ERRORS',
} as const;
export type AssessmentStatusEnum = (typeof AssessmentStatusEnum)[keyof typeof AssessmentStatusEnum];

export function instanceOfAssessmentStatusEnum(value: any): boolean {
  for (const key in AssessmentStatusEnum) {
    if (Object.prototype.hasOwnProperty.call(AssessmentStatusEnum, key)) {
      if ((AssessmentStatusEnum as Record<string, AssessmentStatusEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function AssessmentStatusEnumFromJSON(json: any): AssessmentStatusEnum {
  return AssessmentStatusEnumFromJSONTyped(json, false);
}

export function AssessmentStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssessmentStatusEnum {
  return json as AssessmentStatusEnum;
}

export function AssessmentStatusEnumToJSON(value?: AssessmentStatusEnum | null): any {
  return value as any;
}
